/*eslint-disable*/
export const getAddedMemberIds = (initialMemberIds=[], memberIds=[]) => {
    const addedMemberIds = memberIds.filter(
      (value) => !initialMemberIds.includes(value)
    );
    return addedMemberIds || []
  };

  const addAddMembersToOperations = ({ groupDTO, initialMemberIds, memberIds }) => {
    const addedMemberIds = getAddedMemberIds(initialMemberIds, memberIds);
    if(addedMemberIds?.length > 0) {
        const addMembersOperation = {
            "op": "add",
            "path": "user",
            "value": addedMemberIds,
          }
          groupDTO.operations.push(addMembersOperation);
    }
    
}
  
  
  export const getDeletedMemberIds = (initialMemberIds=[], memberIds=[]) => {
      const deletedMemberIds = initialMemberIds.filter(
        (value) => !memberIds.includes(value)
      );
      return deletedMemberIds || []
    };

    const addRemoveMembersToOperations = ({ groupDTO, initialMemberIds, memberIds }) => {
        const deletedMemberIds = getDeletedMemberIds(initialMemberIds, memberIds);
        if(deletedMemberIds?.length > 0) {
            const removeMembersOperation = {
                "op": "remove",
                "path": "user",
                "value": deletedMemberIds,
              }
              groupDTO.operations.push(removeMembersOperation);
        }
    }
    
    export const makeEditGroupDTO = (group={}, selectedMembers=[]) => {
        const groupDTO = {
            schemas: "urn:ietf:params:scim:api:messages:2.0:PatchOp",
            operations: [],
          };
          const initialMemberIds = group.members?.map(member => member?.value)
          const memberIds = selectedMembers.map(member => member?.value);
          addRemoveMembersToOperations({ groupDTO, initialMemberIds, memberIds });
          addAddMembersToOperations({ groupDTO, initialMemberIds, memberIds });
          return groupDTO;
    }

    const getMemberIds = members => members?.map(member => member?.value);

    export const getSelectedMembersCount = (group={}) => selectedMembers => {
      const initialMemberIds = getMemberIds(group?.members);
      const memberIds = getMemberIds(selectedMembers);
      const addedMemberIds = getAddedMemberIds(initialMemberIds, memberIds);
      const deletedMemberIds = getDeletedMemberIds(initialMemberIds, memberIds);
      return addedMemberIds.length + deletedMemberIds.length;
    }
